import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Shopee_Acount from './shopee-account';
import Shopee_Orders from './shopee-orders';


import Error404 from '../Error404';


export default ({ match }) => {
    return (
        <Switch>
            <Route path={`${match.path}/shopee-account`} component={Shopee_Acount} />
            <Route path={`${match.path}/shopee-orders`} component={Shopee_Orders} />
            <Route component={Error404} />
        </Switch>
    )
}
